exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".col-sm-2[_v-43fd51e7]{padding:0;margin-right:15px}i[_v-43fd51e7]{color:#d8d8d8;font-size:20px;padding:5px}textarea[_v-43fd51e7]{width:100%}.textarea-container[_v-43fd51e7]{padding:0 15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-43fd51e7&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/Admin/Admin-projects-general.vue
// module id = 427
// module chunks = 0